import React, { Component } from "react";
import { Route, Switch, Redirect, withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import * as _ from "lodash";
import { Layout, Menu, Icon } from "antd";
import { getUser } from "../utils/token";
import { checkPermission } from "../utils/helper";

import "./App.scss";
import "antd/dist/antd.css";

import NotFound from "./NotFound";
import Forbidden from "./Forbidden";

import Login from "./Login";
// import Reset from "./Reset";

import LayoutHeader from "./LayoutHeader";
import Attendance from "./Attendance";
import EmailTemplate from "./EmailTemplate";
import EventPage from "./EventPage";
import Home from "./Home";
import Overview from "./Overview";
// import Profile from "./Profile";
import Registration from "./Registration";
import RegistrationField from "./RegistrationField";
import Ticket from "./Ticket";
import Scan from "./Scan";
import User from "./User";
import UserRole from "./UserRole";
import AuditLog from "./AuditLog";
import EmailLog from "./EmailLog";

moment.updateLocale(moment.locale(), { invalidDate: "N/A" });

const genericErrors = {
  401: {
    title: "Resource not Found",
    message: "Unable to load resource",
  },
  500: {
    title: "Internal Server Error",
    message: "The server was unable to complete your request.",
  },
  502: {
    title: "Bad Gateway",
    message: "The server was unable to complete your request.",
  },
  503: {
    title: "Service Unavailable",
    message: "The server was unable to complete your request.",
  },
};

const paths = [
  // {
  //   slug: "admin/reset/:token",
  //   route: "/admin/reset/:token",
  //   label: "Reset",
  //   component: Reset,
  //   display: [""],
  // },
  {
    route: "/403",
    label: "Forbidden",
    component: Forbidden,
  },
  {
    route: "/scan",
    label: "Scan",
    component: Scan,
  },
  {
    route: "/attendance",
    label: "Attendance",
    component: Attendance,
  },
  {
    route: "/email-template",
    label: "EmailTemplate",
    component: EmailTemplate,
  },
  {
    route: "/event-page",
    label: "EventPage",
    component: EventPage,
  },
  {
    route: "/home",
    label: "Dashboard",
    component: Home,
  },
  {
    route: "/admin",
    label: "Dashboard",
    component: Home,
  },
  {
    route: "/overview",
    label: "Overview",
    component: Overview,
  },
  {
    route: "/registration",
    label: "Registration",
    component: Registration,
  },
  {
    route: "/registration-field",
    label: "RegistrationField",
    component: RegistrationField,
  },
  {
    route: "/ticket",
    label: "Ticket",
    component: Ticket,
  },
  {
    route: "/login",
    label: "Login",
    component: Login,
  },
  {
    route: "/user",
    label: "User",
    component: User,
  },
  {
    route: "/user-role",
    label: "UserRole",
    component: UserRole,
  },
  {
    route: "/audit-log",
    label: "AuditLog",
    component: AuditLog,
  },
  {
    route: "/email-log",
    label: "EmailLog",
    component: EmailLog,
  },
  {
    route: "/",
    label: "Login",
    component: Login,
  },
];

const sider = [
  {
    item_group: false,
    name: "Dashboard",
    key: "dashboard",
    link: "/",
    icon: "dashboard",
  },
  {
    item_group: true,
    name: "Settings",
    key: "settings",
    icon: "setting",
    items: [
      {
        item_group: false,
        name: "Overview",
        key: "overview",
        link: "/overview",
        icon: "calendar",
      },
      {
        item_group: false,
        name: "Email Template",
        key: "email-template",
        link: "/email-template",
        icon: "mail",
      },
      {
        item_group: false,
        name: "Event Page",
        key: "event-page",
        link: "/event-page",
        icon: "layout",
      },
      {
        item_group: false,
        name: "Registration Fields",
        key: "registration-field",
        link: "/registration-field",
        icon: "profile",
      },
      {
        item_group: false,
        name: "Tickets",
        key: "ticket",
        link: "/ticket",
        icon: "qrcode",
      }
    ]
  },
  {
    item_group: true,
    name: "Participants",
    key: "participant",
    icon: "team",
    items: [
      {
        item_group: false,
        name: "Registration",
        key: "registration",
        link: "/registration",
        icon: "user-add",
      },
      {
        item_group: false,
        name: "Attendance",
        key: "attendance",
        link: "/attendance",
        icon: "schedule",
      },
      {
        item_group: false,
        name: "Scan",
        key: "scan",
        link: "/scan",
        icon: "scan",
      },
    ]
  },
  {
    item_group: true,
    name: "Logs",
    key: "log",
    // icon: "team",
    items: [
      {
        item_group: false,
        name: "Audit Log",
        key: "audit-log",
        link: "/audit-log",
        icon: "audit",
      },
      {
        item_group: false,
        name: "Email Log",
        key: "email-log",
        link: "/email-log",
        icon: "idcard",
      },
    ]
  },
  {
    item_group: true,
    name: "System Settings",
    key: "system-settings",
    // icon: "team",
    items: [
      {
        item_group: false,
        name: "Users",
        key: "users",
        link: "/user",
        icon: "user",
      },
      {
        item_group: false,
        name: "User Roles",
        key: "user-roles",
        link: "/user-role",
        icon: "team",
      },
    ]
  }
];

const toastXHRError = (code) => {
  const error = genericErrors[code];
  if (error) {
    console.error(error.title, error.message);
  }
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      selectedEvent: {}
    };

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        switch (error.response.status) {
          case 401 /* signout() */:
            break;
          case 404:
            toastXHRError(404);
            break;
          case 500:
            toastXHRError(500);
            break;
          case 502:
            toastXHRError(502);
            break;
          case 503:
            toastXHRError(503);
            break;
          default:
            break;
        }
        return Promise.reject(error);
      }
    );

    axios.defaults.transformResponse = axios.defaults.transformResponse
      .concat
      // (response) => func(response)
      ();
  }

  // componentDidMount () {
  //   if (isLocalStorageEmpty()) {
  //     this.setState({ isLoggedIn: false })
  //   } else {
  //     this.setState({ isLoggedIn: true })
  //   }
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props.loggedIn !== nextProps.loggedIn && nextProps.loggedIn) {
  //     this.setState({ isLoggedIn: true });
  //     // window.location.reload()
  //   }
  // }

  handleSelectEvent = (event) => {
    this.setState({
      selectedEvent: event,
    });
  }

  render() {
    const { selectedEvent } = this.state;
    const user = getUser();

    if (window.location.pathname != "/login" && !user) {
      window.location.href = "/login";
      return;
    }

    const pageException = ["/403", "/404", "/login", "/profile"];

    return (
      <Layout className="layout">
        <Layout.Content>

          {this.props.history.location.pathname !== "/" && this.props.history.location.pathname !== "/login" ? (
            <LayoutHeader handleSelectEvent={this.handleSelectEvent} />
          ) : (
            ""
          )}

          <Layout className="sub-layout">
            {this.props.history.location.pathname !== "/" && this.props.history.location.pathname !== "/login" ? (
              <Layout.Sider className="sub-layout_sider" theme="light">
                {selectedEvent && selectedEvent.id ? (
                  <Menu
                    style={{ height: "100%", padding: "20px 10px" }}
                    mode="inline"
                  >
                    {sider.map(item => {
                      if (item && item.items) {
                        let hasChildPermission = false;
                        item.items.forEach(sub => {
                          if (checkPermission(sub.key, "view")) {
                            hasChildPermission = true;
                          }
                        });

                        if (hasChildPermission) {
                          return (
                            <Menu.ItemGroup key={item.key} title={
                              <span>
                                <Icon type={item.icon} />
                                <span>{item.name}</span>
                              </span>
                            }>
                              {item.items.map(subItem => {
                                if (checkPermission(subItem.key, "view")) {
                                  return (
                                    <Menu.Item key={subItem.key}>
                                      <Link to={subItem.link}>
                                        <Icon type={subItem.icon} />
                                        {subItem.name}
                                      </Link>
                                    </Menu.Item>
                                  );
                                } else {
                                  return ('');
                                }
                              })}
                            </Menu.ItemGroup>
                          );
                        } else {
                          return ('');
                        }
                      } else {
                        if (checkPermission(item.key, "view")) {
                          return (
                            <Menu.Item key={item.key}>
                              <Link to={item.link}>
                                <Icon type={item.icon} />
                                {item.name}
                              </Link>
                            </Menu.Item>
                          );
                        } else {
                          return ('');
                        }
                      }
                    })}
                  </Menu>
                ) : (
                  ""
                )}
              </Layout.Sider>
            ) : (
              ""
            )}

            <Layout.Content className="sub-layout-content">
              <Switch className="sub-layout_content_switch">
                {window.scrollTo(0, 0)}
                {paths.map((path) => {
                  // if (!checkPermission(path.route.replace("/", ""), "view")) {
                  //   return (<Redirect key={path.route} to="/403" />);
                  // }

                  return (
                    <Route
                      key={path.route}
                      // exact={path.exact}
                      path={path.route}
                      component={path.component}
                      render={(props) => <path.component {...props} {...this.state} eventttt={selectedEvent} />}
                    />
                  );
                })}
                <Route component={NotFound} />
                <Route component={Forbidden} />
                <Redirect to="/404" />
              </Switch>
            </Layout.Content>
          </Layout>

          {/* {
            this.props.history.location.pathname !== "" && this.props.history.location.pathname !== "/login" ? (
              // <Footer {...this.props} paths={paths} />
              <Layout.Footer>&nbsp;</Layout.Footer>
            ) : (
              ""
            )
          } */}
        </Layout.Content >
      </Layout >
    );
  }
}

function mapStateToProps(state) {
  return {
    loggedIn: state.login.loggedIn,
    state: state,
  };
}

export default withRouter(connect(mapStateToProps, {})(App));
